import {
  GetAllObjectsToDisplayFromView,
  GetViewLayersResponse,
  GetViewResponse,
  GetViewsByProjectIdsResponse,
  CreateViewResponse,
  AddViewLayerResponse,
  GetFavoriteDashboardsResponse,
  GetAllObjectsFromViewResponse,
  AddObjectToViewResponse,
  UpdateObjectFromViewResponse,
  ApiEnveloppe,
  UpdateViewResponse,
  UpdateLayersOrderResponse,
} from '../../types/types';
import { _post, requestType } from './_internal';

export const getViewByProjectIds = (payload: {
  list_project_id: any;
}): Promise<GetViewsByProjectIdsResponse> => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_vues,
    list_project_id: payload.list_project_id,
  });
};

export const getView = (payload: {
  view_id: number;
}): Promise<GetViewResponse> => {
  return _post<GetViewResponse>({
    request_type: requestType.recuperer_une_vue,
    view_id: payload.view_id,
  });
};

export const createView = (payload: any): Promise<CreateViewResponse> => {
  return _post({ request_type: requestType.creer_une_vue, ...payload });
};

export const addViewLayer = (payload: any): Promise<AddViewLayerResponse> => {
  return _post({
    request_type: requestType.ajouter_une_couche_de_vue,
    ...payload,
  });
};

export const getViewLayers = (payload: {
  view_id: string;
}): Promise<{ data: GetViewLayersResponse }> => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_couches_de_vue,
    view_id: payload.view_id,
  });
};

export const getFavoriteDashboards =
  (): Promise<GetFavoriteDashboardsResponse> => {
    return _post({
      request_type: requestType.recuperer_la_liste_des_tableaux_de_bord_favoris,
    });
  };

export const updateLayersOrder = (payload: {
  view_id: string;
  layers_position_order_list: any;
}): Promise<UpdateLayersOrderResponse> => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_tableaux_de_bord_favoris,
    view_id: payload.view_id,
    layers_position_order_list: payload.layers_position_order_list,
  });
};

export const deleteLayerFromView = (payload: {
  layer_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_une_couche_de_vue,
    layer_id: payload.layer_id,
  });
};

export const updateView = (payload: any): Promise<UpdateViewResponse> => {
  return _post({ request_type: requestType.modifier_une_vue, ...payload });
};

export const deleteView = (payload: {
  view_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_une_vue,
    view_id: payload.view_id,
  });
};

export const getAllObjectsFromView = (payload: {
  view_id: string;
}): Promise<GetAllObjectsFromViewResponse> => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_objets_associe_a_la_vue,
    view_id: payload.view_id,
  });
};

export const addObjectToView = (payload: {
  view_id: number;
  viewobj: any;
}): Promise<AddObjectToViewResponse> => {
  return _post({
    request_type: requestType.ajouter_un_objet_associe_a_la_vue,
    view_id: payload.view_id,
    viewobj: payload.viewobj,
  });
};

export const updateObjectFromView = (payload: {
  viewobj_id: number;
  view_id: number;
  viewobj: any;
}): Promise<UpdateObjectFromViewResponse> => {
  return _post({
    request_type: requestType.modifier_un_objet_associe_a_la_vue,
    ...payload,
  });
};

export const removeObjectFromView = (payload: {
  viewobj_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_un_objet_associe_a_la_vue,
    viewobj_id: payload.viewobj_id,
  });
};

export const getAllObjectsToDisplayFromView = (payload: {
  view_id: string;
}): Promise<GetAllObjectsToDisplayFromView> => {
  return _post({
    request_type:
      requestType.recuperer_la_liste_des_objets_a_afficher_associes_a_une_vue,
    view_id: payload.view_id,
  });
};

export const getAdditonalDataOfObject = (payload: {
  view_id: string;
  viewobj_id: string;
}) => {
  return _post({
    request_type:
      requestType.recuperer_les_informations_complementaires_d_un_objet,
    view_id: payload.view_id,
    viewobj_id: payload.viewobj_id,
  });
};
